import React, { useState, useEffect } from "react";
import ReactFlagsSelect from "react-flags-select";

interface CountrySelectorProps {
  onChange: (selectedOption: { countryData: string }) => void;
  country: string;
  }

const CountryPicker: React.FC<CountrySelectorProps> = ({
  onChange,
  country,
}) => {
  const defaultCountryCode = "LK"; // Default country code
  const [selected, setSelected] = useState(defaultCountryCode);
  // const [countryName, setCountryName] = useState("");

  // Country code to country name mapping
  const customLabels: Record<string, string> = {
    LK: "Sri Lanka",
    US: "United States",
    GB: "United Kingdom",
    FR: "France",
    DE: "Germany",
    IN: "India",
    AU: "Australia",
    CA: "Canada",
    CN: "China",
    JP: "Japan",
    BR: "Brazil",
  };

  // Set the default country name on component mount
  useEffect(() => {
    if(country){
    onChange({ countryData: selected }); 

    }
  }, []);

  useEffect(() => {
    if(country){
    if (country.length == 2) {
      setSelected(country);
    } else {
      const countryCode = getCountryCodeByName(country);
      setSelected(countryCode);
    }
  }
  }, [country]);

  const getCountryCodeByName = (countryName: string): string => {
    return (
      Object.entries(customLabels).find(
        ([name]) => name === countryName
      )?.[0] || "LK"
    );
  };

  const handleSelect = (code: string) => {
    setSelected(code);
  };

  useEffect(()=>{
    const selectedCountry = customLabels[selected] || selected;
    onChange({ countryData: selectedCountry });
  },[selected])

  return (
    <div>
      <ReactFlagsSelect
        selected={selected}
        onSelect={handleSelect}
        placeholder="Select Country"
        searchable
        searchPlaceholder="Search Country"
        optionsSize={13}
        customLabels={customLabels}
        className="text-sm text-gray-500 Blinker-Regular"
        
      />
    </div>
  );
};

export default CountryPicker;
